const  BottomButtonWrapper=({children,grid=1})=>{

    return  <div className="w-full  fixed bg-white flex justify-center z-10  left-0 bottom-0 p-3  ">
                <div className={`w-full md:w-6/12    lg:w-5/12 xl:w-4/12 grid gap-2 grid-cols-${grid}`}>
                    {children}
                </div>
            </div>
}
export default BottomButtonWrapper;